import { Component, OnInit ,ViewChild} from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MasterService } from '../masters/master.service';
import * as CommonConstants from 'src/app/utils/common.constants';
import { DynamicFormService } from '../dynamic-form-builder/dynamic-form-service';
import { ToastrService } from 'ngx-toastr';
import { AddHospitalComponent } from '../partners/hospitals/add-hospital/add-hospital.component';
@Component({
  selector: 'app-myspace-hospital',
  templateUrl: './myspace-hospital.component.html',
  styleUrls: ['./myspace-hospital.component.scss']
})
export class MyspaceHospitalComponent implements OnInit {
  partnerId=+localStorage.getItem(CommonConstants.PARTNER_ID);
  partnerType=+localStorage.getItem(CommonConstants.PARTNER_TYPE);
  rowId=1;
  fieldsProfResHuman: any[] = [];
  fieldsProfResEquipmnt: any[] = [];
  fieldsProfResActivities: any[] = [];
  fieldsProfResDoctors: any[] = [];
  fieldsProfActiPublications: any[] = [];
  fieldsProfActiEducation:any[]=[];
  fieldsProfActiTreatment:any[]=[];
  fieldsProfPOriginNational:any[]=[];
  fieldsProfPOriginRatio:any[]=[];
  fieldQualityHospital:any[]=[];
  fieldQualityCertification:any[]=[];
  fieldQualityHrActivity:any[]=[];
  fieldQualitySecurityPatient:any[]=[];
  fieldQualitySecurityInfection:any[]=[];
  fieldQualitySecurityActivity:any[]=[];
  fieldQualityEvaluationHospital:any[]=[];
  fieldQualityEvaluationStaff:any[]=[];
  fieldQualityEvaluationProfessionals:any[]=[];
  fieldQualityOtherEvalutionOrganism:any[]=[];
  fieldQualityOtherEvaluationPaying:any[]=[];
  fieldFinancialServices:any[]=[];
  fieldFinancialPackages:any[]=[];
  fieldFinancialUnpaidBills:any[]=[];

  //Transactional
  listProfResHuman: any[] = [];
  listProfResEquipmnt: any[] = [];
  listProfResActivities: any[] = [];
  listProfResDoctors: any[] = [];
  listProfActiPublications: any[] = [];
  listProfActiEducation:any[]=[];
  listProfActiTreatment:any[]=[];
  listProfPOriginNational:any[]=[];
  listProfPOriginRatio:any[]=[];
  listQualityHospital:any[]=[];
  listQualityCertification:any[]=[];
  listQualityHrActivity:any[]=[];
  listQualitySecurityPatient:any[]=[];
  listQualitySecurityInfection:any[]=[];
  listQualitySecurityActivity:any[]=[];
  listQualityEvaluationHospital:any[]=[];
  listQualityEvaluationStaff:any[]=[];
  listQualityEvaluationProfessionals:any[]=[];
  listQualityOtherEvalutionOrganism:any[]=[];
  listQualityOtherEvaluationPaying:any[]=[];
  listFinancialServices:any[]=[];
  listFinancialPackages:any[]=[];
  listFinancialUnpaidBills:any[]=[];
  @ViewChild(AddHospitalComponent, { static: true }) hospital: AddHospitalComponent;
  
  ngOnInit() {
    this.hospital.loadHospitalById(this.partnerId);
    this.masterService.getMasterForms(20).subscribe(response => {
      if (response && response['result']) {
        this.fieldsProfResHuman = response['result'];
      }
    })
    this.masterService.getMasterForms(21).subscribe(response => {
      if (response && response['result']) {
        this.fieldsProfResEquipmnt = response['result'];
      }
    })
    this.masterService.getMasterForms(22).subscribe(response => {
      if (response && response['result']) {
        this.fieldsProfResActivities = response['result'];
      }
    })
    this.masterService.getMasterForms(23).subscribe(response => {
      if (response && response['result']) {
        this.fieldsProfResDoctors = response['result'];
      }
    })
    this.masterService.getMasterForms(24).subscribe(response => {
      if (response && response['result']) {
        this.fieldsProfActiPublications = response['result'];
      }
    })
    this.masterService.getMasterForms(25).subscribe(response => {
      if (response && response['result']) {
        this.fieldsProfActiEducation = response['result'];
      }
    })
    this.masterService.getMasterForms(26).subscribe(response => {
      if (response && response['result']) {
        this.fieldsProfActiTreatment = response['result'];
      }
    })
    this.masterService.getMasterForms(27).subscribe(response => {
      if (response && response['result']) {
        this.fieldsProfPOriginNational = response['result'];
      }
    })
    this.masterService.getMasterForms(28).subscribe(response => {
      if (response && response['result']) {
        this.fieldsProfPOriginRatio = response['result'];
      }
    })
    this.masterService.getMasterForms(29).subscribe(response => {
      if (response && response['result']) {
        this.fieldQualityHospital = response['result'];
      }
    })
    this.masterService.getMasterForms(30).subscribe(response => {
      if (response && response['result']) {
        this.fieldQualityCertification = response['result'];
      }
    })
    this.masterService.getMasterForms(42).subscribe(response => {
      if (response && response['result']) {
        this.fieldQualityHrActivity = response['result'];
      }
    })
    this.masterService.getMasterForms(31).subscribe(response => {
      if (response && response['result']) {
        this.fieldQualitySecurityPatient = response['result'];
      }
    })
    this.masterService.getMasterForms(32).subscribe(response => {
      if (response && response['result']) {
        this.fieldQualitySecurityInfection = response['result'];
      }
    })
    this.masterService.getMasterForms(33).subscribe(response => {
      if (response && response['result']) {
        this.fieldQualitySecurityActivity = response['result'];
      }
    })
    this.masterService.getMasterForms(34).subscribe(response => {
      if (response && response['result']) {
        this.fieldQualityEvaluationHospital = response['result'];
      }
    })
    this.masterService.getMasterForms(35).subscribe(response => {
      if (response && response['result']) {
        this.fieldQualityEvaluationStaff = response['result'];
      }
    })
    this.masterService.getMasterForms(36).subscribe(response => {
      if (response && response['result']) {
        this.fieldQualityEvaluationProfessionals = response['result'];
      }
    })
    this.masterService.getMasterForms(37).subscribe(response => {
      if (response && response['result']) {
        this.fieldQualityOtherEvalutionOrganism = response['result'];
      }
    })
    this.masterService.getMasterForms(38).subscribe(response => {
      if (response && response['result']) {
        this.fieldQualityOtherEvaluationPaying = response['result'];
      }
    })
    this.masterService.getMasterForms(39).subscribe(response => {
      if (response && response['result']) {
        this.fieldFinancialServices = response['result'];
      }
    })
    this.masterService.getMasterForms(40).subscribe(response => {
      if (response && response['result']) {
        this.fieldFinancialPackages = response['result'];
      }
    })
    this.masterService.getMasterForms(41).subscribe(response => {
      if (response && response['result']) {
        this.fieldFinancialUnpaidBills = response['result'];
      }
    })


    //transactional
    this.dynamicForm.getFormData(20,this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.listProfResHuman = response['result'];
      }
    })

    this.dynamicForm.getFormData(21,this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.listProfResEquipmnt = response['result'];
      }
    })
    this.dynamicForm.getFormData(22,this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.listProfResActivities = response['result'];
        return this.listProfResActivities;
      }
    })
    this.dynamicForm.getFormData(23,this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.listProfResDoctors = response['result'];
        return this.listProfResDoctors;
      }
    })
    this.dynamicForm.getFormData(24,this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.listProfActiPublications = response['result'];
        return this.listProfActiPublications;
      }
    })
    this.dynamicForm.getFormData(25,this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.listProfActiEducation = response['result'];
        return this.listProfActiEducation;
      }
    })
    this.dynamicForm.getFormData(26,this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.listProfActiTreatment = response['result'];
        return this.listProfActiTreatment;
      }
    })
    this.dynamicForm.getFormData(27,this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.listProfPOriginNational = response['result'];
        return this.listProfPOriginNational;
      }
    })
    this.dynamicForm.getFormData(28,this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.listProfPOriginRatio = response['result'];
        return this.listProfPOriginRatio;
      }
    })
    this.dynamicForm.getFormData(29,this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.listQualityHospital = response['result'];
        return this.listQualityHospital;
      }
    })
    this.dynamicForm.getFormData(30,this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.listQualityCertification = response['result'];
        return this.listQualityCertification;
      }
    })
    this.dynamicForm.getFormData(42,this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.listQualityHrActivity = response['result'];
        return this.listProfResActivities;
      }
    })
    this.dynamicForm.getFormData(31,this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.listQualitySecurityPatient = response['result'];
        return this.listQualitySecurityPatient;
      }
    })
    this.dynamicForm.getFormData(32,this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.listQualitySecurityInfection = response['result'];
        return this.listQualitySecurityInfection;
      }
    })
    this.dynamicForm.getFormData(33,this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.listQualitySecurityActivity = response['result'];
        return this.listQualitySecurityActivity;
      }
    })
    this.dynamicForm.getFormData(34,this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.listQualityEvaluationHospital = response['result'];
        return this.listQualityEvaluationHospital;
      }
    })
    this.dynamicForm.getFormData(35,this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.listQualityEvaluationStaff = response['result'];
        return this.listQualityEvaluationStaff;
      }
    })
    this.dynamicForm.getFormData(36,this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.listQualityEvaluationProfessionals = response['result'];
        return this.listQualityEvaluationProfessionals;
      }
    })
    this.dynamicForm.getFormData(37,this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.listQualityOtherEvalutionOrganism = response['result'];
        return this.listQualityOtherEvalutionOrganism;
      }
    })
    this.dynamicForm.getFormData(38,this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.listQualityOtherEvaluationPaying = response['result'];
        return this.listQualityOtherEvaluationPaying;
      }
    })
    this.dynamicForm.getFormData(39,this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.listFinancialServices = response['result'];
        return this.listFinancialServices;
      }
    })
    this.dynamicForm.getFormData(40,this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.listFinancialPackages = response['result'];
        return this.listFinancialPackages;
      }
    })
    this.dynamicForm.getFormData(41,this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.listFinancialUnpaidBills = response['result'];
        return this.listFinancialUnpaidBills;
      }
    })
  }
  public form: FormGroup;
  unsubcribe: any

  public fields: any[] = [
    {
      type: 'text',
      name: 'firstName',
      label: 'First Name',
      value: '',
      required: true,
    },
    {
      type: 'text',
      name: 'lastName',
      label: 'Last Name',
      value: '',
      required: true,
    },
    {
      type: 'text',
      name: 'email',
      label: 'Email',
      value: '',
      required: true,
    },

    {
      type: 'dropdown',
      name: 'country',
      label: 'Country',
      value: 'in',
      required: true,
      options: [
        { key: 'in', label: 'India' },
        { key: 'us', label: 'USA' }
      ]
    },
   
  ];
  public rowData: any[] = [];
  constructor(private masterService:MasterService,private dynamicForm:DynamicFormService,private toastrService:ToastrService) {
    this.form = new FormGroup({
      fields: new FormControl(JSON.stringify(this.fields))
    })
    this.unsubcribe = this.form.valueChanges.subscribe((update) => {
     // console.log(update);
      this.fields = JSON.parse(update.fields);
    });
  }

  onUpload(e) {
    console.log(e);

  }

  getFieldsHumanResources() {
    this.fields=this.fieldsProfResHuman;
    return this.fieldsProfResHuman;
  }
  getFieldsTopEquipments() {
    this.fields=this.fieldsProfResEquipmnt;
    return this.fieldsProfResEquipmnt;
  }
  getFieldsActivities() {
    this.fields=this.fieldsProfResActivities;
    return this.fieldsProfResActivities;
  }
  getFieldsLeadingDoctors() {
    this.fields=this.fieldsProfResDoctors;
    return this.fieldsProfResDoctors;
  }
  getFieldsPublications() {
    this.fields=this.fieldsProfActiPublications;
    return this.fieldsProfActiPublications;
  }
  getFieldsEducation() {
    this.fields=this.fieldsProfActiEducation;
    return this.fieldsProfActiEducation;
  }
  getFieldsTreatments() {
    this.fields=this.fieldsProfActiTreatment;
    return this.fieldsProfActiTreatment;
  }
  getFieldsPatientOrigin() {
    this.fields=this.fieldsProfPOriginNational;
    return this.fieldsProfPOriginNational;
  }
  getFieldsPatientRatio() {
    this.fields=this.fieldsProfPOriginRatio;
    return this.fieldsProfPOriginRatio;
  }
  getFieldsHospitalQuality() {
    this.fields=this.fieldQualityHospital;
    return this.fieldQualityHospital;
  }
  getFieldsQualityCertifications() {
    this.fields=this.fieldQualityCertification;
    return this.fieldQualityCertification;
  }
  getFieldsHRActivities() {
    this.fields=this.fieldQualityHrActivity;
    return this.fieldQualityHrActivity;
  }
  getFieldsPatientSecurity() {
    this.fields=this.fieldQualitySecurityPatient;
    return this.fieldQualitySecurityPatient;
  }
  v
  getFieldsFightAgainstInfection() {
    this.fields=this.fieldQualitySecurityInfection;
    return this.fieldQualitySecurityInfection;
  }
  getFieldsActivityQuality() {
    this.fields=this.fieldQualitySecurityActivity;
    return this.fieldQualitySecurityActivity
  }
  getFieldsHospitalEvaluations() {
    this.fields=this.fieldsProfResHuman;
    return this.fieldQualityEvaluationHospital;
  }
  getFieldsStaffEvaluations() {
    this.fields=this.fieldQualityEvaluationStaff;
    return this.fieldQualityEvaluationStaff;
  }
  getFieldsProfessionalEvaluations() {
    this.fields=this.fieldQualityEvaluationProfessionals;
    return this.fieldQualityEvaluationProfessionals;
  }
  getFieldsOrganismEvaluations() {
    this.fields=this.fieldQualityOtherEvalutionOrganism;
    return this.fieldQualityOtherEvalutionOrganism;
  }
  getFieldsPayngEvaluations() {
    this.fields=this.fieldsProfResHuman;
    return this.fieldQualityOtherEvaluationPaying;
  }
  getFieldsFinancialServices() {
    this.fields=this.fieldFinancialServices;
    return this.fieldFinancialServices;
  }
  getFieldsFinancialPackages() {
    this.fields=this.fieldFinancialPackages;
    return this.fieldFinancialPackages;
  }
  getFieldsFinancialUnpaidBills() {
    this.fields=this.fieldFinancialUnpaidBills;
    return this.fieldFinancialUnpaidBills;
  }
  ngDistroy() {
    this.unsubcribe();
  }
  setForm(){
    console.log("yes we can do it")
  }
  save(event,formId){
    //First Get The row id
    this.dynamicForm.getMaxRowId(formId,this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.rowId = response['result'];
        this.rowId=this.rowId+1;
      }
      let formData=[];
      Object.keys(event).forEach(name => {
        let keyValue=this.fields.filter(item => item.name===name)[0].key;
        let obj={};
        obj["formId"]=formId;
        obj["key"]=keyValue;
        obj["value"]=event[name];
        obj["rowId"]=this.rowId;
        obj["partnerId"]=this.partnerId;
        obj["partnerType"]=this.partnerType;
       // obj["runId"]=1;
        obj["keyName"]=name;
        formData.push(obj);
      });
      //console.log(JSON.stringify(formData));
      this.dynamicForm.saveFormData(formData).subscribe(res => {
        if (res && res["result"]) {
          this.toastrService.success("Saved Succesffully");
          
        }
      })
    
    })
    
  }
  getListHumanResources() {
    return this.listProfResHuman
  }
  getListTopEquipments() {
   return this.listProfResEquipmnt;
  }
  getListActivities() {
   return this.listProfResActivities; 
  }

  getListLeadingDoctors() {
    return this.listProfResDoctors;
  }
  getListPublications() {
    return this.listProfActiPublications;
  }
  getListEducation() {
    return this.listProfActiEducation;
  }
  getListTreatments() {
    return this.listProfActiTreatment;
  }
  getListPatientOrigin() {
    return this.listProfPOriginNational;
  }
  getListPatientRatio() {
    return this.listProfPOriginRatio;
  }
  getListHospitalQuality() {
    return this.listQualityHospital;
  }
  getListQualityCertifications() {
    return this.listQualityCertification;
  }
  getListHRActivities() {
    return this.listQualityHrActivity;
  }
  getListPatientSecurity() {
    return this.listQualitySecurityPatient;
  }
  getListFightAgainstInfection() {
    return this.listQualitySecurityInfection;
  }
  getListActivityQuality() {
    return this.listQualitySecurityActivity
  }
  getListHospitalEvaluations() {
    return this.listQualityEvaluationHospital;
  }
  getListStaffEvaluations() {
    return this.listQualityEvaluationStaff;
  }
  getListProfessionalEvaluations() {
    return this.listQualityEvaluationProfessionals;
  }
  getListOrganismEvaluations() {
    return this.listQualityOtherEvalutionOrganism;
  }
  getListPayngEvaluations() {
    return this.listQualityOtherEvaluationPaying;
  }
  getListFinancialServices() {
    return this.listFinancialServices;
  }
  getListFinancialPackages() {
    return this.listFinancialPackages;
  }
  getListFinancialUnpaidBills() {
    return this.listFinancialUnpaidBills;
  }
}
